module.exports = __webpack_public_path__ + "img/t_0007.31764a98.gif";